export const translations = {
  ru: {
    nav: {
      about: "Обо мне",
      projects: "Проекты",
      whyMe: "Почему я?",
      contact: "Контакты",
    },
    home: {
      title: "Привет,<br />я",
      subtitle: "разработчик",
      description:
        "которому нравится создавать функциональные, красивые и сложные интерфейсы... и корги",
      cta: "Проекты",
    },
    about: {
      title: "Обо мне",
      text1:
        "Меня зовут Давлат, и вот уже 5-й год я занимаюсь веб-разработкой. За плечами множество интересных проектов.",
      text2:
        "<span>&#10004;</span> Погружен в мир Javascript (4+ года). Уверенное владение Vue 3, Nuxt 3, Vuex/Pinia, Vite/Webpack, npm/npx и git.",
      text3:
        "<span>&#10004;</span> Обладаю опытом работы с REST API, Websockets, PWA, Axios и JSON. <br />Верстаю адаптивные, кроссбраузерные интерфейсы, придерживаясь методологии БЭМ и используя инструменты Tailwind, Sass(SCSS), Bootstrap.",
      text4:
        "<span>&#10004;</span> Хорошо знаком c E2E(Playwright), Typescript, React, Redux, Pixi и Tween.js, GitHub/Gitlab, Figma.",
      text5:
        "<span>&#10004;</span> Магистр технических наук (2 высших тех. образования). <br />Умею успешно разбираться в чужом коде, быстро осваивая новые концепции и методологии.",
      resume: "Посмотреть резюме",
      resumeTitle: "Актуальная версия резюме",
    },
    projects: {
      title: "Портфолио",
    },
    whyMe: {
      title: "Почему я?",
      text1:
        "<span>&#10004;</span> <strong>Инженерная база:</strong> 2 высших тех. образования (в т.ч. Инженер ИИ) и доп. курсы (Ulbi TV, JavaScript.Ninja) сформировали системный подход, позволяющий мне автономно и быстро решать задачи.",
      text2:
        "<span>&#10004;</span> <strong>Инженерный подход:</strong> Практикую осознанное внедрение нейросетей, используя их для ускорения разработки и TTM, оставляя за собой архитектуру и контроль качества.",
      text3:
        "<span>&#10004;</span> <strong>Работа с legacy и чужим кодом:</strong> За годы практики я участвовал в самых разных проектах — от стартапов до сложных экосистем. Быстро разбираюсь в чужом коде, провожу рефакторинг, сохраняя её работоспособность.",
      text4:
        "<span>&#10004;</span> <strong>Продукт важнее кода:</strong> Мне не всё равно, над чем я работаю. Я всегда погружаюсь в бизнес-процессы компании, чтобы понимать, зачем мы это делаем.",
    },
    contact: {
      title: "Связаться со мной:",
    },
    footer: {
      text: "© 2023 - Developed by",
    },
  },
  en: {
    nav: {
      about: "About me",
      projects: "Projects",
      whyMe: "Why me?",
      contact: "Contact",
    },
    home: {
      title: "Hi,<br />I'm",
      subtitle: "developer",
      description:
        "who enjoys creating functional, beautiful, and complex interfaces... and corgis",
      cta: "Projects",
    },
    about: {
      title: "About me",
      text1:
        "My name is Davlat, and I've been working in web development for 5 years now. I have many interesting projects under my belt.",
      text2:
        "<span>&#10004;</span> Deeply immersed in JavaScript (4+ years). Proficient in Vue 3, Nuxt 3, Vuex/Pinia, Vite/Webpack, npm/npx, and git.",
      text3:
        "<span>&#10004;</span> Experience with REST API, Websockets, PWA, Axios, and JSON. <br />I create responsive, cross-browser interfaces using BEM methodology and tools like Tailwind, Sass(SCSS), and Bootstrap.",
      text4:
        "<span>&#10004;</span> Familiar with E2E(Playwright), Typescript, React, Redux, Pixi, Tween.js, GitHub/Gitlab, and Figma.",
      text5:
        "<span>&#10004;</span> Master of Technical Sciences (2 technical degrees). <br />I can quickly understand other people's code and master new concepts and methodologies.",
      resume: "View Resume",
      resumeTitle: "Latest resume version",
    },
    projects: {
      title: "Portfolio",
    },
    whyMe: {
      title: "Why me?",
      text1:
        "<span>&#10004;</span> <strong>Engineering foundation:</strong> 2 technical degrees (including AI Engineer) and additional courses (Ulbi TV, JavaScript.Ninja) have developed a systematic approach that allows me to work autonomously and solve tasks quickly.",
      text2:
        "<span>&#10004;</span> <strong>Engineering approach:</strong> I practice conscious AI integration, using them to speed up development and TTM while retaining architecture and quality control.",
      text3:
        "<span>&#10004;</span> <strong>Working with legacy and other people's code:</strong> Over the years, I've worked on various projects — from startups to complex ecosystems. I quickly understand other people's code and perform refactoring while maintaining functionality.",
      text4:
        "<span>&#10004;</span> <strong>Product matters more than code:</strong> I care about what I work on. I always immerse myself in the company's business processes to understand why we're doing this.",
    },
    contact: {
      title: "Contact me:",
    },
    footer: {
      text: "© 2023 - Developed by",
    },
  },
};
